import { userRoute } from "pages/user/user.routes"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import styled from "styled-components"
import { ClassCard } from "ui/base/class/ClassCard"
import { SelectButton } from "ui/base/selectInput/SelectButton"
import { mediaSizes, pageContainerStyles, themeColor } from "ui/theme"

const sortOptions = [
  { value: "popularity", label: "Popularity" },
  { value: "price", label: "Price" },
]

const PAGE_SIZE = 20

export const OnlineSearchSection = ({
  query,
  classes,
  sortBy,
  onSortChange,
  online_type,
}) => {
  const navigate = useNavigate()
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE)

  const visibleClasses = classes.slice(0, visibleCount)
  const hasMore = visibleCount < classes.length

  return (
    <Wrapper>
      <TitleSection>
        <PageTitle>{query}</PageTitle>
        <Subtitle>{classes.length} instructors available</Subtitle>
      </TitleSection>

      <Controls>
        <ShowingText>
          Showing 1–{visibleClasses.length} of {classes.length} results
        </ShowingText>
        <SortContainer>
          <SelectButton
            borderColor='transparent'
            controlledMenu={false}
            showIndicator
            placeholder='Default sorting'
            bgColor='transparent'
            valueColor='txt'
            chevronColor='#191D3A'
            value={sortBy}
            onChange={onSortChange}
            options={sortOptions}
            height='40px'
            width='100%'
            textAlign='right'
          />
        </SortContainer>
      </Controls>

      <Grid>
        {visibleClasses.map((item, index) => (
          <ClassCard
            key={index}
            classData={item}
            onClick={() =>
              navigate(userRoute.classDetail + item.user_id, {
                state: { online_type },
              })
            }
            online_type={online_type}
          />
        ))}
      </Grid>

      {hasMore && (
        <ShowMoreRow>
          <ShowMoreBtn onClick={() => setVisibleCount((c) => c + PAGE_SIZE)}>
            Show More
          </ShowMoreBtn>
        </ShowMoreRow>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  ${pageContainerStyles}
  padding-top: 2.5rem;
  padding-bottom: 5rem;
  font-family: Montserrat, sans-serif;
  min-height: 84dvh;

  @media (width >= ${mediaSizes.md}) {
    padding-top: 3.75rem;
  }

  @media (width >= ${mediaSizes.lg}) {
    padding-inline: 3.125rem;
  }
`

const TitleSection = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  gap: 6px;
`

const PageTitle = styled.h1`
  font-family: Montserrat, sans-serif;
  font-size: 1.75rem;
  font-weight: 400;
  color: ${themeColor("txt")};
  margin: 0;

  @media (width >= ${mediaSizes.md}) {
    font-size: 2.25rem;
  }
`

const Subtitle = styled.p`
  font-family: Montserrat, sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
  color: ${themeColor("txt")};
  opacity: 0.6;
  margin: 0;
`

const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`

const ShowingText = styled.p`
  font-family: Poppins, sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  color: ${themeColor("txt")};
  opacity: 0.7;
`

const SortContainer = styled.div`
  min-width: 140px;
  margin-right: -14px;
  font-family: Poppins, sans-serif;
  font-weight: 500;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem 1rem;

  @media (width >= ${mediaSizes.xs}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (width >= ${mediaSizes.md}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 2.5rem 1.25rem;
  }

  @media (width >= ${mediaSizes.lg}) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 2.5rem 1.5rem;
  }
`

const ShowMoreRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3rem;
`

const ShowMoreBtn = styled.button`
  all: unset;
  cursor: pointer;
  font-family: Montserrat, sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  color: ${themeColor("txt")};
  border: 1.5px solid rgba(29, 29, 31, 0.35);
  border-radius: 100px;
  padding: 12px 40px;
  transition:
    border-color 0.2s ease,
    background 0.2s ease;

  &:hover {
    border-color: ${themeColor("txt")};
    background: rgba(29, 29, 31, 0.04);
  }
`
